import type { FC } from "react";
import React from "react";
import styles from "./Loader.module.scss";

export const Loader: FC<{
    percentage?: number;
    infinite?: boolean;
}> = ({ percentage = 1, infinite = true }) => {
    if (!infinite && percentage === 1) {
        return null;
    }

    const fullCircle = 2 * Math.PI * 20;
    return (
        <svg viewBox="25 25 50 50" className={`${styles.loader} ${infinite ? styles.infinite : ""}`}>
            <circle
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray={`${fullCircle * (infinite ? 0.75 : percentage)} ${fullCircle}`}
            />
        </svg>
    );
};
